import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';

import { DestinationActions } from '../actions';
import { DestinationService } from '../destination.service';

@Injectable()
export class DestinationEffects {
  private actions$ = inject(Actions);
  private destinationService = inject(DestinationService);

  loadDestination$ = createEffect(() => this.actions$
    .pipe(
      ofType(DestinationActions.loadDestination),
      exhaustMap(({ slugOrId }) => this.destinationService
        .get(slugOrId)
        .pipe(
          map(destination => DestinationActions.loadDestinationSuccess({ destination })),
          catchError(error => of(DestinationActions.loadDestinationFailure({ error }))),
        ),
      ),
    ));

  loadDestinations$ = createEffect(() => this.actions$
    .pipe(
      ofType(DestinationActions.loadDestinations),
      exhaustMap(({ storefront }) => this.destinationService
        .getAll(storefront)
        .pipe(
          map(destinations => DestinationActions.loadDestinationsSuccess({ destinations })),
          catchError(error => {
            return of(DestinationActions.loadDestinationsFailure({ error }));
          }),
        ),
      ),
    ));
}

